/**
 * IndividualMetricInsights component exports
 *
 * Provides detailed metric insights with textual explanation and historical chart.
 */

export { default } from "./IndividualMetricInsightsContainer";
export { default as IndividualMetricInsightsContainer } from "./IndividualMetricInsightsContainer";
export { default as IndividualMetricInsightsView } from "./IndividualMetricInsightsView";
